import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('virtualAccountBalance', {
    ordinal: 0,
    roundToDollar: true,
    hidden: false,
  });
